import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.css']
})
export class DatepickerComponent implements OnInit {
    events: string[] = [];

    constructor(public datepipe: DatePipe){}

    @Output() newItemEvent = new EventEmitter<any>();

    addNewItem(type: string, event: MatDatepickerInputEvent<Date>) : void {
        this.newItemEvent.emit(this.datepipe.transform(event.value, 'yyyy-MM-dd'));
    }

    ngOnInit(): void {
    }


}
